/* eslint-disable */
import { List, Select } from "antd";
import { useEffect, useState } from "react";
import Compliance, { ComplianceItem } from "./Compliance";
import * as React from "react";

export interface CompliancesProps {
    dataSource: ComplianceItem[];
}

const Compliances: React.FC<CompliancesProps> = ({ dataSource }) => {
    const [status, setStatus] = useState<string>("all");
    const [filteredDataSource, setFilteredDataSource] = useState<ComplianceItem[]>([]);
    useEffect(() => {
        switch (status) {
            case "all":
                setFilteredDataSource(dataSource);
                break;
            case "opened":
                setFilteredDataSource(dataSource.filter((i) => i?.active));
                break;
            case "closed":
                setFilteredDataSource(dataSource.filter((i) => !i?.active));
                break;
        }
    }, [status])
    return (
        <List
            dataSource={filteredDataSource}
            header={
                <Select
                    data-testid="ric-compliance-status-select"
                    defaultValue={status}
                    style={{ width: "100%", maxWidth: 300, marginBottom: 10 }}
                    onChange={(value: string) => setStatus(value)}
                    options={[
                        { value: 'all', label: 'All' },
                        { value: 'opened', label: 'Opened' },
                        { value: 'closed', label: 'Closed', },
                    ]}
                />}
            renderItem={(item => <>
                <Compliance compliance={item} />
            </>)} />
    );
};

export default Compliances